import { render } from "./calculatorComponent.vue?vue&type=template&id=4c756458"
import script from "./calculatorComponent.vue?vue&type=script&lang=js"
export * from "./calculatorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__